export default function audioSpriteKey(segment) {
  return segment.wordStart.toString();
}
